module.exports = __webpack_public_path__ + "img/server-dashboard.53a1b0e5.svg";